import { useOutletContext } from 'react-router-dom';
import type { EchoKey } from '@/utils/constants';

export interface MainLayoutContext {
  selectedEcho: EchoKey;
  setSelectedEcho: (echoKey: EchoKey) => void;
  // Allow triggering the mobile menu from nested pages
  setIsMobileMenuOpen: (isOpen: boolean) => void;
  // Signals that a heavy UI transition (like sidebar opening) is happening (Performance Mode)
  isTransitioning: boolean;
}

export const useChatContext = () => useOutletContext<MainLayoutContext>();
